import React, { Component } from "react";
import { displayAutoCloseConfig } from "../display-auto-close-config";
import { displayAdminsAccessConfig } from "../display-admins-access-config";
import { translate } from "../../../infrastructure/translate/localization";

export default class ConfigurationPage extends Component {
  componentDidMount() {
    displayAutoCloseConfig();
    displayAdminsAccessConfig();
  }

  render() {
    return (
      <main className="section">
        <div className="section-header">
          <h1 className="section-title">
            {translate("configuration-section.configuration")}
          </h1>
          <div id="notification-card" />
        </div>
        <div className="section-container">
          <div className="container-flex" id="auto-close-config-container" />
          <div className="container-flex" id="admins-access-config" />
        </div>
      </main>
    );
  }
}
